import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const JobPostingHelp = () => {
  const isMdScreen = IsMdScreen();

  return (
    <Stack direction="row" spacing={2}>
      <ShContainer maxWidth='xl' sx={{ flex: 1 }}>
        <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
          Job Posting Management
        </ResourceTypography>
        <ResourceTypography variant="body1" paragraph>
          Create, manage, and optimize your job postings to attract the best candidates.
          Learn how to write compelling job descriptions and use our tools to maximize visibility.
        </ResourceTypography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Creating Job Postings
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Step-by-step guide to creating effective job postings, including writing job descriptions,
          setting requirements, and adding screening questions to filter candidates.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Job Posting Optimization
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Learn how to optimize your job postings with keywords, formatting, and best practices
          to improve visibility and attract qualified candidates.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Job Posting Templates
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Save time by using and customizing job posting templates for different roles.
          Create consistent, high-quality job descriptions across your organization.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Posting Distribution
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Maximize your job posting reach by distributing to multiple job boards and
          social media platforms with a single click.
        </Typography>

        <Box paddingTop={2} paddingBottom={3}>
          <ShButton
            component={RouterLink}
            to="/employer/jobs/create"
            color="primary"
            variant="contained"
          >
            Create New Job Posting
          </ShButton>
        </Box>
      </ShContainer>
      {!isMdScreen && <CommonQuestionSidebar />}
    </Stack>
  );
};

export default JobPostingHelp; 